<script>

import Layout from "../../layouts/main";
import Heading from "../../layouts/heading";
import { schema, doctorNames, chatData, chatMessagesData } from "./data";
import JsonForm from "../../layouts/form";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";

export default {
  page: {
    title: "Opening Hours Page",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, JsonForm, Heading },
  data() {
    return {
      valueTextArea: '',
      valueNote: '',
      value: null,
      enabled5: false,
      editorData: "Hello World",
      chatData: chatData,
      chatMessagesData: chatMessagesData,
      doctorNames: doctorNames,
      schema: schema,
      formData: {
        title: 'Opoening Hours Page',
        slug: 'opening_hours_page',
        page_icon: '',
        page_desc: 'hello world',
        note_block: 'test 123'
      },
      page: {
        title: "Opening Hours Page",
        lastUpdated: '31 Dec 2020 15:00',
        addNewBtn: false,
        deleteBtn: true,
        activeBtn: true,
        submitBtn: true
      }, 
      submitted: false,
    };
  },
  validations: {
    form: {
      message: { required },
    },
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<template>
  <Layout>
    <Heading :page="page"></Heading>
    <div class="d-lg-flex mb-4 w-75">
      <div class="w-100 mt-4 mt-sm-0">
        <div class="py-3 px-2">
          <div class="row px-2">
            <JsonForm :schema="schema" :formData="formData"></JsonForm>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>